import React from "react";
import { host } from "@Services/url";
import { setUrlFormat } from "@Lib/common";
import OverflowTooltip from "@Components/overflowTooltip";

interface IKindCarItem {
  item: any;
  visible?: boolean;
}

const KindCarItem: React.FC<IKindCarItem> = ({ item, visible }) => {
  const {
    ads,
    brandId,
    brandName,
    discountTitle,
    inquiry,
    kindId,
    kindName,
    price,
    rightTips,
    tag,
    thumb,
    tips,
    modelNum,
    usedCarLink,
  } = item;

  return (
    <div
      id='KindCarItem'
      className={`w-220 ${visible ? "h-280" : "h-250"} px-12 relative  hover:box-shadow`}
      style={{ border: "1px solid #E8E8E8" }}
    >
      {!!rightTips.content && (
        <div
          className='absolute right-6 top-2 text-12 text-[#999]'
          onClick={() => {
            if (!!rightTips.link) {
              window.open(rightTips.content, "_blank");
            }
          }}
        >
          {rightTips.content}
        </div>
      )}
      {!!tips && (
        <div
          className='h-20 text-12 items-center text-[#2B62E1] pl-4 pr-8 rounded-br-8 inline-flex absolute -top-1 left-0 gap-10'
          style={{ background: "linear-gradient(90deg,#ddebff, #f0f5ff)" }}
        >
          {tips}
        </div>
      )}
      {!!tag && <div className='text-12 text-[#999] right-6 top-0 h-20 flex items-center absolute'>{tag}</div>}
      <a
        target='_blank'
        href={ads?.adclick || `${host.c}/photoModel-info.html?k=${item.kindId}`}
      // className='w-168 h-112 object-cover mx-auto mt-12 block'
      >
        <div className='w-168 h-112 object-cover mx-auto mt-12 block'>
          <img className='w-full' src={thumb} width={168} height={112} />
        </div>

        <OverflowTooltip tooltipTitle={`${brandName} ${kindName}`}>
          <div className='truncate text-16 text-black text-center'>{brandName} {kindName}</div>
        </OverflowTooltip>
        
        <div className='mt-6 text-[#FF3232] text-center text-16'>{price}</div>
        {visible && (
          <div className='truncate text-12 text-black text-center mt-6 h-18 w-180 mx-auto'>{discountTitle}</div>
        )}
        <div className='truncate text-12 text-[#999] text-center mt-6 h-18'>共{modelNum}台符合條件車型</div>
      </a>
      <div className='flex gap-12 mt-12 items-center justify-center'>
        {!!usedCarLink && !inquiry && (
          <a
            href={usedCarLink}
            className='w-84 h-30 flex items-center justify-center rounded-4 text-12 text-white bg-[#F87F15] hover:text-white'
            target='_blank'
          >
            中古車
          </a>
        )}
        {!!inquiry && (
          <a
            href={ads?.adclick || `${host.c}/ask/price?b=${brandId}&k=${kindId}&source=廠牌找車-熱門詢價`}
            className='w-84 h-30 flex items-center justify-center rounded-4 text-12 text-white bg-[#FF4333] hover:text-white'
            target='_blank'
          >
            一鍵詢價
          </a>
        )}
        <a
          href={`${host.c}/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/Specification.html`}
          className='w-84 h-30 flex items-center justify-center rounded-4 text-12 text-[#333]'
          style={{ border: "1px solid #666" }}
          target='_blank'
        >
          配備
        </a>
      </div>
    </div>
  );
};

export default KindCarItem;
